"use client";

import { collectorHealth } from "@/lib/system-health";
import type { CollectorRun, Tone } from "@/lib/types";
import { Activity } from "lucide-react";
import { CollectButton } from "./collect-button";
import { LogoutButton } from "./logout-button";

const healthColor: Record<Tone, string> = {
  positive: "text-[var(--hc-positive)]",
  warning: "text-[var(--hc-warning)]",
  danger: "text-[var(--hc-negative)]",
  neutral: "text-[var(--hc-muted)]"
};

export function TopBar({ collectorRun, title, kicker }: { collectorRun: CollectorRun | null; title: string; kicker: string }) {
  const health = collectorHealth(collectorRun);
  return (
    <header data-top-bar className="sticky top-0 z-20 border-b border-[var(--hc-border)] bg-[var(--hc-surface-1)] px-4 py-3 md:px-6">
      <div className="mx-auto flex max-w-[1600px] flex-wrap items-center justify-between gap-3">
        <div>
          <p className="text-[10px] font-semibold uppercase tracking-[0.14em] text-[var(--hc-muted)]">{kicker}</p>
          <h1 className="text-lg font-semibold tracking-[-0.02em] text-[var(--hc-text)] sm:text-xl">{title}</h1>
        </div>
        <div className="flex items-center gap-2 sm:gap-3">
          <CollectButton collectorRun={collectorRun} />
          <div data-system-health={health.label.toLowerCase()} className="hidden items-center gap-2 border-r border-[var(--hc-border)] pr-3 text-xs text-[var(--hc-muted)] sm:flex" title={health.detail}>
            <Activity size={15} className={healthColor[health.tone]} aria-hidden="true" />
            <span><span className={healthColor[health.tone]}>{health.label}</span> · {health.detail}</span>
          </div>
          <LogoutButton />
        </div>
      </div>
    </header>
  );
}
